export default __webpack_public_path__ + "static/fa-solid-900-289a6bf80200b8e5092f3873e0294a29.woff2";